
import { Component, Vue, Watch } from 'vue-property-decorator';
import { SnackConfig } from '../../types';
import _snack from '../services/Snack';

@Component({ components: {} })
export default class SnackHub extends Vue {
  lastSnack: Partial<SnackConfig> = {};

  showSnackbar = false;

  timeout: number | undefined;

  get topSnack(): SnackConfig | undefined {
    return _snack.topSnack;
  }

  showSnack(snack: SnackConfig) {
    // Allow the snackbar to start its hiding animation
    this.showSnackbar = false;
    // Give it a tiny bit of time to possibly show movement
    const timeout = this.timeout ? 100 : 0;
    setTimeout(() => {
      // Show the new snack
      this.showSnackbar = true;
      this.lastSnack = snack;
      this.createTimer(snack.timeout || 5000, snack.remove);
    }, timeout);
  }

  createTimer(timeout: number, callback: () => void) {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.timeout = setTimeout(() => {
      this.timeout = undefined;
      this.showSnackbar = false;
      callback();
    }, timeout);
  }

  enqueueCleanup() {
    const { lastSnack } = this;
    setTimeout(() => {
      if (this.lastSnack === lastSnack) {
        this.lastSnack = {};
      }
    }, 500);
  }

  @Watch('topSnack')
  onTopSnackChanged(value: SnackConfig | undefined) {
    if (value) {
      this.showSnack(value);
    } else {
      // Release the lastSnack resource when there are not more snacks to show
      this.enqueueCleanup();
    }
  }
}
